module.exports = __webpack_public_path__ + "/images/hellobb-premium-banner-large.b5a5bd7.png";